/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { LineBasicMaterial, Vector3, Geometry, Line, Color } from 'three';
/**
 * line that will not be detected by the raycaster
 */
export class AuxiliaryLine extends Line {
    constructor(color = new Color('yellow')) {
        super(new Geometry(), new LineBasicMaterial({ color }));
        this._p1 = new Vector3(0, 0, 0);
        this._p2 = new Vector3(0, 0, 0);
        this.geometry.vertices.push(this._p1);
        this.geometry.vertices.push(this._p2);
        this.geometry.verticesNeedUpdate = true;
        this.userData.imaginary = true;
        this.visible = false;
    }
    enable(e) {
        this.visible = e;
    }
    setP1(p1) {
        this._p1.copy(p1);
        this.geometry.verticesNeedUpdate = true;
    }
    setP2(p2) {
        this._p2.copy(p2);
        this.geometry.verticesNeedUpdate = true;
    }
    getLength() {
        return this._p2.distanceTo(this._p1);
    }
}
//# sourceMappingURL=AuxiliaryLine.js.map